import React from 'react';
import MapViewer from './components/MapViewer';

function App() {
  return (
    <div className="App">
      <MapViewer />
    </div>
  );
}

export default App;
